import { action, observable } from 'mobx';
import { clearPlaceholderBirthday } from '@link/share/utils';
import { accountApi } from '@link/shop/services';
import { Account as AccountType } from '@link/shop/services/types';

export class Account {
  @observable accessor accountInfo: AccountType = {};

  getAccountInfo() {
    return accountApi.getAccount().then(res => {
      const account = clearPlaceholderBirthday(
        res.account ?? ({} as AccountType)
      );
      this.setAccountInfo(account);
      return account;
    });
  }

  @action
  setAccountInfo(account: AccountType) {
    this.accountInfo = account;
  }

  submitAccountInfo(account: AccountType) {
    return accountApi.updateAccount({
      body: {
        account
      }
    });
  }
}

export default new Account();
